import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

export const GuaiPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '{blue.50}',
      100: '{blue.100}',
      200: '{blue.200}',
      300: '{blue.300}',
      400: '{blue.400}',
      500: '{blue.500}',
      600: '{blue.600}',
      700: '{blue.700}',
      800: '{blue.800}',
      900: '{blue.900}',
      950: '{blue.950}'
    },
    formField: {
      paddingX: '0.75rem',
      paddingY: '0.75rem'
    },
    list: {
      padding: '0.75rem 0',
      header: { padding: '0.75rem 1.25rem' },
      option: { padding: '0.75rem 1.25rem' },
      optionGroup: { padding: '0.75rem 1.25rem' }
    },
    navigation: {
      list: { padding: '0.25rem 0' },
      item: { padding: '0.75rem 1.25rem' }
    },
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '{gray.50}',
          100: '{gray.100}',
          200: '{gray.200}',
          300: '{gray.300}',
          400: '{gray.400}',
          500: '{gray.500}',
          600: '{gray.600}',
          700: '{gray.700}',
          800: '{gray.800}',
          900: '{gray.900}',
          950: '{gray.950}'
        },
        text: {
          color: '{surface.600}',
          hoverColor: '{surface.700}',
          mutedColor: '{surface.500}',
          hoverMutedColor: '{surface.600}'
        },
        formField: {
          color: '{surface.600}',
          disabledBackground: '{form.field.background}',
          disabledColor: '{form.field.color}'
        },
        list: {
          option: { focusBackground: '{surface.200}', focusColor: '{text.color}' }
        },
        navigation: {
          item: { focusBackground: '{surface.200}' }
        }
      }
    }
  },
  components: {
    card: {
      root: { borderRadius: '6px' },
      body: { padding: '1.25rem', gap: '0' }
    },
    badge: {
      root: { borderRadius: '10px' }
    },
    accordion: {
      header: { padding: '1.25rem', hoverColor: '{surface.700}', activeColor: '{surface.700}' },
      content: { padding: '1.25rem' }
    },
    multiselect: {
      dropdown: { width: '3rem' }
    },
    datatable: {
      headerCell: { padding: '1rem' },
      footerCell: { padding: '1rem' }
    },
    tag: {
      root: { gap: '0' }
    },
    tabs: {
      tabpanel: { padding: '1.25rem' }
    },
    paginator: {
      root: { gap: '0', borderRadius: '0', color: '{text.muted.color}' }
    },
    rating: {
      icon: { size: '1.143rem', color: '{text.color}' }
    },
    checkbox: {
      root: { width: '22px', height: '22px', borderRadius: '6px' }
    }
  }
});
